import styled from 'styled-components';
import { palette } from 'styled-theme';

const AppHolder = styled.div`
  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 16px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .isoSearchContainer {
    .ant-input-search {
      .ant-input-group {
        .ant-input {
          height: 32px;
          font-size: 13px;
        }
      }
    }
  }

  .trigger:hover {
    color: ${palette('primary', 0)};
  }

  .ant-layout-sider-collapsed .anticon {
    font-size: 16px;
  }

  .ant-layout-sider-collapsed .nav-text {
    display: none;
  }

  .ant-form-explain {
    font-size: 13px;
  }

  .ant-input {
    font-size: 13px;
  }

  .ant-btn {
    font-size: 13px;
  }

  .ant-select {
    font-size: 13px;
  }

  .ant-form label {
    font-size: 13px;
  }

  .ant-tabs-nav-container {
    font-size: 13px;
  }

  .ant-layout {
    background: ${palette('primary', 1)};

    &.isoContentMainLayout {
      overflow: auto;
      overflow-x: hidden;
      @media only screen and (min-width: 768px) and (max-width: 1220px) {
        width: calc(100% - 80px);
        flex-shrink: 0;
      }

      @media only screen and (max-width: 767px) {
        width: 100%;
        flex-shrink: 0;
      }
    }
  }

  .isoLayoutContent {
    width: 100%;
    padding: 35px;
    background-color: ${palette('secondary', 1)};
    border: 1px solid ${palette('border', 1)};
    height: 100%;
  }

  .isomorphicLayout {
    width: calc(100% - 240px);
    flex-shrink: 0;
    overflow-x: hidden !important;

    @media only screen and (max-width: 767px) {
      width: 100%;
    }

    @media only screen and (min-width: 768px) and (max-width: 1220px) {
      width: calc(100% - 80px);
    }
  }

  .ant-layout-footer {
    font-size: 13px;
    @media (max-width: 767px) {
      padding: 10px 20px;
    }
  }

  .dx-user-icon {
    height: 23px;
    width: 23px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .dx-datagrid {
    background-color: #fff0;
  }

  .dx-datagrid-header-panel {
    border-bottom: 0px;
  }

  .dx-datagrid-pager {
    border-top: 0px;
  }

  .dx-widget {
    font-size: 12px;
    .dx-rtl
      .dx-datagrid-rowsview
      .dx-selection.dx-row
      > td:not(.dx-focused).dx-datagrid-group-space,
    .dx-rtl
      .dx-datagrid-rowsview
      .dx-selection.dx-row:hover
      > td:not(.dx-focused).dx-datagrid-group-space {
      border-left-color: #4670a2;
    }
    .dx-group-panel-message {
      font-size: 12px;
    }

    .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-lines) > td,
    .dx-datagrid-rowsview .dx-selection.dx-row:hover:not(.dx-row-lines) > td {
      border-bottom: 1px solid #4670a2;
      border-top: 1px solid #4670a2;
    }

    .dx-datagrid-rowsview .dx-selection.dx-row > td.dx-datagrid-group-space,
    .dx-datagrid-rowsview
      .dx-selection.dx-row:hover
      > td.dx-datagrid-group-space {
      border-right-color: #4670a2;
    }

    .dx-datagrid-rowsview .dx-selection.dx-row > td,
    .dx-datagrid-rowsview .dx-selection.dx-row:hover > td {
      background-color: #4670a2;
      color: #fff;
    }

    .dx-datagrid-table
      .dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row)
      > td:not(.dx-focused) {
      background-color: #4670a2;
      color: #fff;
    }

    .dx-field-item-content {
      font-size: 13px;
    }

    .dx-field-item-label-text {
      font-size: 13px;
    }

    .dx-datagrid-content .dx-datagrid-table .dx-row > td,
    .dx-datagrid-content .dx-datagrid-table .dx-row > tr > td {
      vertical-align: middle;
    }

    .dx-overlay-wrapper {
      font-size: 13px;
    }
  }
`;

export default AppHolder;
